import { Component, Input, OnInit } from '@angular/core';
import { FabButton, FabOptions } from '../../service/fab.service';
import { speedDialFabAnimations } from './speed-dial-fab.animations';
import { NgClass } from '@angular/common';
import { MatFabButton } from '@angular/material/button';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatChipListbox, MatChipOption, MatChipAvatar } from '@angular/material/chips';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { SibatTranslatePipe } from '../../pipes/sibat-translate.pipe';

@Component({
  selector: 'sibat-speed-dial-fab',
  templateUrl: './speed-dial-fab.component.html',
  styleUrls: ['./speed-dial-fab.component.scss', '../../buttons/buttons.scss'],
  animations: speedDialFabAnimations,
  imports: [
    NgClass,
    MatFabButton,
    TranslocoDirective,
    MatChipListbox,
    MatChipOption,
    MatTooltip,
    MatIcon,
    MatChipAvatar,
    SibatTranslatePipe,
  ],
})
export class SpeedDialFabComponent {
  @Input() options: FabOptions;
  @Input() hidden = false;
  @Input() disabled = false;

  buttons: FabButton[] = [];
  fabTogglerState = 'inactive';

  showItems() {
    this.fabTogglerState = 'active';
    this.buttons = this.options.buttons;
  }

  hideItems() {
    this.fabTogglerState = 'inactive';
    this.buttons = [];
  }

  toggle() {
    if (this.buttons.length > 0) {
      this.hideItems();
    } else {
      this.showItems();
    }
  }
}
